import { Component, Input, TemplateRef, ViewChild } from '@angular/core';
import { WidgetsEntity } from "../../models/widget-entity.model";
import { ToastService } from 'src/app/services/toast.service';

@Component({
  selector: 'app-main-frame',
  templateUrl: './main-frame.component.html',
  styleUrls: ['./main-frame.component.scss']
})
export class MainFrameComponent {

  @Input() widgets?: (WidgetsEntity | null)[] | null;

  @ViewChild('successTpl') successTpl!: TemplateRef<any>;
  @ViewChild('dangerTpl') dangerTpl!: TemplateRef<any>;


  constructor(private toastService: ToastService) { }

  ngOnInit(): void {
    this.toastService.addTemplate('success', this.successTpl);
    this.toastService.addTemplate('danger', this.dangerTpl);
  }

  showDanger(template: TemplateRef<any>) {
    this.toastService.show({ template, classname: 'bg-danger text-light', delay: 15000 });
  }
}
